import BodyPartsTrueFalse from "../../components/UKG/GeneralAwareness/BodyPartsTrueFalse";
import FillBlanksBodyParts from "../../components/UKG/GeneralAwareness/FillBlanksBodyParts";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/ukg/general-awareness/parts-of-body/fill-the-blanks", title: "Fill In The Blanks", component: FillBlanksBodyParts},
    { url: "/ukg/general-awareness/parts-of-body/true-false", title: "True & False", component: BodyPartsTrueFalse},
];


export default topics;